export const InterviewRoute = 'interview'
